import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.css';

const TabBar = ({ brandColor, tabs }) => {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <div className="d-flex flex-column justify-content-end h-100">
      {tabs && Array.isArray(tabs) && (
        <ul className="list-unstyled d-flex justify-content-center m-0 mt-2">
          {tabs.map((tab, idx) => {
            const tabIsActive = (isActive) =>
              tab.isActive ? tab.isActive(location) : isActive;
            return (
              <li key={idx}>
                <NavLink
                  to={tab.link}
                  end={tab.exact}
                  onClick={tab.onClick}
                  className={({ isActive }) =>
                    cn(styles.app_nav__link, {
                      [styles.app_nav__link_active]: tabIsActive(isActive),
                    })
                  }
                  style={({ isActive }) =>
                    tabIsActive(isActive) ? { color: brandColor } : undefined
                  }
                >
                  <span>{t(tab.title)}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default TabBar;
